import React, { useContext, useState } from "react";
import { FiWifi, FiCopy, FiCheck } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { AuthContext, AuthContextType } from "../../../contexts/auth-context";
import "./Wifi.scss";

function Wifi() {
  const { user } = useContext<AuthContextType>(AuthContext);
  const { t } = useTranslation();
  const [copiedNetwork, setCopiedNetwork] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);

  const copyToClipboard = async (text: string, type: 'network' | 'password') => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === 'network') {
        setCopiedNetwork(true);
        setTimeout(() => setCopiedNetwork(false), 2000);
      } else {
        setCopiedPassword(true);
        setTimeout(() => setCopiedPassword(false), 2000);
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const hasWifiInfo = user?.wifiNetworkName || user?.wifiPassword;

  return (
    <div className="wifi-page dark-theme">
      <div className="wifi-container">
        <div className="wifi-card">
          {/* Header */}
          <div className="wifi-header">
            <div className="wifi-header__icon">
              <FiWifi size={36} />
            </div>
            <h1 className="wifi-header__title">{t("wifi.title")}</h1>
            <p className="wifi-header__subtitle">
              {t("wifi.subtitle")}
            </p>
          </div>

          {hasWifiInfo ? (
            <div className="wifi-info">
              {user?.wifiNetworkName && (
                <div className="wifi-info__item">
                  <div className="wifi-info__row">
                    <div className="wifi-info__content">
                      <p className="wifi-info__label">{t("wifi.networkName")}</p>
                      <p className="wifi-info__value">{user.wifiNetworkName}</p>
                    </div>
                    <button
                      className={`wifi-copy-btn ${copiedNetwork ? 'wifi-copy-btn--copied' : ''}`}
                      onClick={() => copyToClipboard(user.wifiNetworkName, 'network')}
                    >
                      {copiedNetwork ? (
                        <>
                          <FiCheck size={14} /> {t("common.copied")}
                        </>
                      ) : (
                        <>
                          <FiCopy size={14} /> {t("common.copy")}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}

              {user?.wifiPassword && (
                <div className="wifi-info__item">
                  <div className="wifi-info__row">
                    <div className="wifi-info__content">
                      <p className="wifi-info__label">{t("wifi.password")}</p>
                      <p className="wifi-info__value wifi-info__value--mono">
                        {user.wifiPassword}
                      </p>
                    </div>
                    <button
                      className={`wifi-copy-btn ${copiedPassword ? 'wifi-copy-btn--copied' : ''}`}
                      onClick={() => copyToClipboard(user.wifiPassword, 'password')}
                    >
                      {copiedPassword ? (
                        <>
                          <FiCheck size={14} /> {t("common.copied")}
                        </>
                      ) : (
                        <>
                          <FiCopy size={14} /> {t("common.copy")}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}

              <p className="wifi-info__hint">
                {t("wifi.copyHint")}
              </p>
            </div>
          ) : (
            <div className="wifi-empty">
              <div className="wifi-empty__icon">
                <FiWifi size={28} />
              </div>
              <h2 className="wifi-empty__title">{t("wifi.notAvailable")}</h2>
              <p className="wifi-empty__text">
                {t("wifi.notAvailableText")}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Wifi;
